import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2026 } from '../SchoolProgram2023/components';


const IndependenceDay5to122026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    
    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2026}/home/events-activities/school-programs/Independence5-12/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/school-programs/Independence5-12/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/school-programs/Independence5-12/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/school-programs/Independence5-12/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/school-programs/Independence5-12/5.webp`;


  
    const photos = [
        {
            src: p1,
            source: p1,
            rows: 2,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 2,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 2,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 2,
            cols: 1,
        }, {
            src: p5,
            source: p5,
            rows: 2,
            cols: 1,
        },
      

       


    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                INDEPENDENCE DAY CELEBRATION
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                 Date: 15 August 2026
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                        National Public School, Yeshwanthpur, celebrated the 80th Independence Day of India on Saturday, 15
August 2026 with patriotic fervour, student enthusiasm and a strong emphasis on the responsibilities that
accompany freedom.                          
                            <br></br>
               The celebrations commenced with the student comperes welcoming the gathering, followed by Nada
Geethe and the National Song. The school Cabinet led the Principal to the flag-hoisting ceremony, where
she hoisted the National Flag, followed by the National Anthem. A disciplined March Past by the Cabinet
members and students added solemnity and pride to the occasion.
                        <br></br>
The programme continued with the felicitation of the CBSE Class 10 and Class 12 Centum Scorers of the
2026 Board Examinations, recognising the students for their outstanding academic achievements. This was
followed by a speech on the significance of Independence.
                        <br></br>
      In her address, the Principal spoke about the true meaning of patriotism and responsible citizenship,
reminding students that love for the nation is reflected not merely in expressions of pride but in the way
one conducts oneself every day. She emphasised the importance of taking accountability for one’s actions,
demonstrating civic sense, respecting one’s responsibilities and contributing positively to society. She
encouraged students to see their education and future careers as opportunities to give back to the
country, observing that by learning, working and building their lives here, and using their knowledge and
skills to contribute to society, they can play a meaningful role in the nation’s progress. She urged them to
understand that patriotism is not confined to occasions such as Independence Day, but is expressed
throughout one’s life by valuing and exercising one’s rights while fulfilling one’s duties and responsibilities
towards the nation.
                        <br></br>
The cultural segment showcased the creativity and talent of the students through a Yoga Performance,
Dance Drama, Street Play, Patriotic Song, Cultural Dance and Fashion Show. The performances celebrated
India's rich heritage, diversity and youthful energy, while reinforcing themes of national pride, unity and
social responsibility.
                    <br></br>
The programme concluded with a Note of Gratitude, bringing to a close a celebration that combined
patriotic spirit, academic excellence and cultural expression.
                    <br></br>
The Independence Day celebration at National Public School, Yeshwanthpur, was a fitting reminder that
the freedom enjoyed today carries with it the responsibility to become accountable, civic-minded and
contributing citizens who help shape the future of the nation.
                                        <br></br>

                                   
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
Celebrating the spirit of freedom with pride and patriotism.
                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default IndependenceDay5to122026;